export const APP_NAME = "Safal";

export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const COMMON = {
  MORE: "More",
  DOB: "Date of Birth",
  KRISHAK: "Krishak",
  FROM_DATE: "From Date",
  TO_DATE: "To Date",
  CALENDER: "Calendar",
  TODAY: "Today",
  REPORTS: "Reports",
  DASHBOARD: "Dashboard",
  SAVE: "Save",
  CROP: "Crop",
  HYBRID: "Hybrid",
  DONE: "Done",
  PREVIOUS: "Previous",
  SELECT: "Select",
  CANCEL: "Cancel",
  OK: "Ok",
  DATE: "Date",
  STATUS: "Status",
  COMPLAIN_TYPE: "Complain Type",
  TICKET_ID: "Ticket Id",
  COMPLETED: "Completed",
  ASSIGNED: "Assigned",
  PLANNED: "Planned",
  NO_OF_DAYS_ACTIVE: "No. of days active",
  ACTIVE_INACTIVE: "Active/Inactive",
  DATE_OF_JOINING: "Date of Joining",
  FDO_TM_NAME: "FDO/TM Name",
  QTY_OF_SAMPLE: "Qty of sample",
  GM_ATTENDED: "GM Attended",
  S2S_FIELD_DAY_TOTAL: "S2S-Field Day Total",
  S2S_FIELD_DAY_ATTENDED: "S2S-Field Day Attended",
  GM_TOTAL: "GM Total",
  REPORT: "Report",
  SUMMARISED_DETAILED: "Summarised/Detailed",
  S2S: "S2S",
  CHECK_VARIETY: "Check Variety",
  PLANNED_DATE: "Planned Date",
  UPDATED_DATE: "Updated Date",
  EDIT: "Edit",
  DELETE: "DELETE",
  CITY: "City",
  TEHSIL: "Tehsil",
  VILLAGE: "Village",
  STATE: "State",
  STAGE_OF_VISIT: "Stage of Visit",
  TYPE: "Type",
  FARMER_REGISTER_NUMBER: "Farmer Register Number",
  FARMER_NOT_REGISTER_NUMBER: "Farmer Not Register Number",
  DISTRICT: "District",
  STREET_ADDRESS: "Street Address",
  ADD: "Add",
  MOBILE: "Mobile",
  NAME: "Name",
  ROLE: "Role",
  EMAIL: "Email",
  MOBILE_NUMBER: "Mobile Number",
  EMPLOYEE_ID: "Employee ID",
  EMPLOYEE_ROLE: "Employee Role",
  EMPLOYEE_NAME: "Employee Name",
  EMPLOYEE_PHONE: "Employee Phone",
  EMPLOYEE_REPORTING_MANAGER: "Employee Reporting Manager",
  HEADQUARTERS: "Headquarters",
  POSTAL_ADDRESS: "Postal Address",
  BACK: "Back",
  LOCATION: "Location",
  GOOD: "Good",
  LEVEL: "Level",
  FARMERS: "Farmers",
  TOTAL: "Total",
  FEEDBACK: "Feedback",
  HARVEST: "Harvest",
  YES: "Yes",
  NO: "No",
  SUBMIT: "Submit",
  SUBMIT_CAP: "SUBMIT",
  CURRENT_PASSWORD: "Current Password",
  NEW_PASSWORD: "New Password",
  CONFIRM_NEW_PASSWORD: "Confirm New Password",
  UPDATE: "Update",
  SEND: "Send",
  APPROVE: "Approve",
  REJECT: "Reject",
  ACCEPT: "Accept",
  NEXT: "Next",
  DOWNLOAD: "Download",
  GENERATE_REPORT: "Generate Report",
  IMAGES: "Images",
  ADD_IMAGES: "Add Images",
  MAX_3: "(max 3)",
  REMARKS: "Remarks",
  PRERAK: "Prerak",
  USER_STATUS: "User Status",
  KNOW_YOUR_PRERAK: "Know Your Prerak?",
  CAN_BE_PRERAK: "Can be a Prerak?",
  VIEW_DETAILED_FARMER_INFORMATION: "View Detailed Farmer Information",
  COMMITMENT: "Commitment",
  SELECT_IMAGE_FROM: "Select image from",
  SELECT_CAMERA: "Select Camera",
  CAMERA: "Camera",
  GALLERY: "Gallery",
  FRONT: "Front",
  SEARCH: "Search",
  REAR: "Rear",
  REGION: "Region",
  FDO_NAME: "FDO Name",
  REPORTING_MANAGER: "Reporting Manager",
  TERRITORY: "Territory",
  SELECT_CROP_GROUP: "Select Crop Group",
  SELECT_CROP: "Select Crop",
  SELECT_USER: "Select Employee",
  MOBILE_NUMBER_OF_FARMER: "Mobile Number of Farmer",
  EDUCATION_STATUS: "Education Status",
  SMART_PHONE_USER_1: "Smart-Phone User",
  APPS_USED: "Apps Used(If above Yes)",
  DUPLICATE: "Duplicate",
  UPLOAD: "Upload",
  HYBRIDS: "Hybrids",
  IS_PRERAK: "Is Prerak? \n Y/N",
  CROPPING_WARNING: "Next Button Only Enable when \n (Total Owned + Total Leased) = (Irrigated + Rainfed) = (Total of all Crops Area)",
  FARMER_NAME: "Farmer Name",
  FARMER_REPORT: "Farmer Report",
  PLANNED_BY_SELF_AND_MANAGER: "Planned By(Self/Manager)",
  IV_RETAILER_AND_FARMER: "IV Retailer / Farmer",
  SUB_ACTIVITY: "Sub Activity",
  ACTIVITY_DATE: "Activity Date",
  GENERATE_OTP: "Generate OTP",
  RESEND_OTP: "Resend OTP",
  CONTINUE: "CONTINUE",
  SELF_PLANNED: "Self Planned",
  ASSIGNED_BY_MANAGER: "Assigned By Manager",
  SELF_PLANED_COMPLETED: "Self Planned Completed",
  ASSIGNED_BY_MANAGER_COMPLETED: "Assigned By Manager Completed ",
  TOTAL_COMPLETED: "Total Completed",
  TOTAL_PENDING: "Total Pending",


  //Messages
  LOCATION_ERROR_MESSAGE: "Unable To Fetch Address",
  NO_INTERNET_CONNECTION: "Please Check Your Internet Network Connection!",
  RETAILER_NOT_FOUND: "This Retailer Does not exist",
  KRISHAK_NOT_FOUND: "This Krishak Does not exist",
  START_DAY_MESSAGE: "Start the day to make any changes.",
  TOKEN_EXPIRED: "Invalid Token.",
  LOGOUT_MESSAGE: "You have some data in Offline. Please sync data before logout",
  OFFLINE_KRISHAK_EDIT_MESSAGE: "Krishak already exists. Please be online to edit krishak.",
  SYNC_SUCCESSFUL: "Sync Successful",
  CLEAR_DATA_SUCCESSFUL: "Clear Data Successful",
  VALID_PHONE_NUMBER: "Please enter valid phone number."
}


export const DATE_FORMATS = {
  DATE_FORMAT: "YYYY-MM-DD",
  DASHBOARD_DATE_FORMAT: "YYYY-MM-DD",
  INDIAN_DATE_FORMAT: "DD-MM-YYYY",
  HARVEST_DATE_FORMAT: "DD/MM/YYYY",
  DATE_TIME_FORMAT: "YYYY-MM-DD HH:mm:ss"
}

export const KRISHAK_INFO_SCREEN = {
  KRISHAK_INFORMATION: "Krishak Information",
  MOBILE_NUMBERS: "Mobile Numbers",
}

export const REPORTS_SCREEN = {
  KRISHAK_REPORT: "Krishak Report",
  PRERAK_REPORT: "Prerak Report",
  USER_STATUS_REPORT: "User Status Report",
  GROUP_MEETING_REPORT: "Group Meeting Report",
  SUB_ACTIVITY: "Sub Activity",
  TYPE_OF_SAMPLE: "Type of Sample",
  SAMPLE_DISTRIBUTION_REPORT: "Sample Distribution Report",
  SAMPLE_TO_SALE_REPORT: "Sample to Sale Report",
  USER_LOCATION: "User Location",
  USER_LOCATION_REPORT: "User Location Report",
}

export const SYNC_SERVICE = {
  DATABASE_NAME: "Safal",
  MASTER_TABLE: "Master",
  KRISHAK_TABLE: "Krishak",
  ACTIVITY_TABLE: "Activity",
  USER_ACTIVITY_TABLE: "UserActivity",
  KRISHAK_IMAGE_TABLE: "KrishakImages",
  KRISHAK_FELLOW_FARMER_IMAGE_TABLE: "KrishakFellowFarmerImages",
  OFFLINE_PLANING_TABLE: "OfflinePlanning",
  CROPS_DATA: "crops",
  NOTIFICATIONS_DATA: "notifications",
  STATES_DATA: "states",
  SYNCHRONIZING: "Synchronizing",
  DATA: "Data",
  PLEASE_WAIT: "Please Wait",
  LAST_SYNC_DATE: "lastSyncDate",
  ACTIVITY_LAST_SYNC_DATE: "activityLastSyncDate",

  ALL_KRISHAK_DATA: "allKrishakData",

  //ALL ACTION KEYS
  ACTION_KRISHAK: "krishak",
  ACTION_ADD_ACTIVITY: "add_activity",
  ACTION_EDIT_ACTIVITY: "edit_activity",
  ACTION_QUALIFICATION: "qualification",
  ACTION_PHONE_APP: "phone_app",
  ACTION_IRRIGATION_SOURCE: "irrigation_source",
  ACTION_AREA_UNIT: "area_unit",
  ACTION_WEIGHT_UNIT: "weight_unit",
  ACTION_INFLUENCE_FACTOR: "influence_factor",
  ACTION_KRISHAK_SOURCE_OF_INFORMATION: "krishak_source_of_information",
  ACTION_KRISHAK_DECISION_MAKING: "krishak_decision_making",
  ACTION_CROP_DAYS: "crop_days",
  ACTION_CROP_PICKING: "crop_picking",
  ACTION_CROP_PLOT_VISIT_CROP_HEALTH: "crop_plot_visit_crop_health",
  ACTION_CROP_QUALITY_GIVEN: "crop_quantity_given",
  ACTION_CROP_ROW_DISTANCE: "crop_row_distance",
  ACTION_CROP_SOWING_SPACING: "crop_sowing_spacing",
  ACTION_DAYS: "days",
  ACTION_FEEDBACK: "feedback",
  ACTION_FIELD_DAMAGE_REASON: "field_damage_reason",
  ACTION_FIELD_DAY_ATTEND: "field_day_attend",
  ACTION_FIELD_DAY_MANAGER: "field_day_manager",
  ACTION_LEVEL: "level",
  ACTION_KRISHAK_CROP: "krishak_crop",
  ACTION_PICKING: "picking",
  ACTION_PLOT_VISIT_CROP_HEALTH: "plot_visit_crop_health",
  ACTION_PLOT_VISIT_STAGE: "plot_visit_stage",
  ACTION_QUALITY_GIVEN: "quantity_given",
  ACTION_REJECT: "reject",
  ACTION_ROW_DISTANCE: "row_distance",
  ACTION_SOWING_SPACING: "sowing_spacing",
  ACTION_TYPE_OF_SAMPLE: "type_of_sample",
  ACTION_STATE: "state",
  ACTION_DISTRICT: "district",
  ACTION_TEHSIL: "tehsil",
  ACTION_VILLAGE: "village",
  ACTION_CROP: "crop",
  ACTION_HYBRID: "hybrid",
  ACTION_COMPETITOR_HYBRID: "competitor_hybrid",
  ACTION_HYBRID_LOCATION_TEHSIL: "hybrid_location_tehsil",
  ACTION_USER_LOCATION: "user_location",
  ACTION_EMPLOYEE: "employee",
  ACTION_RETAILER: "retailer",
  ACTION_SUB_ACTIVITY: "sub_activity",
  ACTION_SEASON: "season",
  ACTION_SAMPLE_TO_SALE_CROP: "sample_to_sale_crop",
  ACTION_GROVER: "grover",
  ACTION_CROP_GROUP: "crop_group",
  ACTION_USER_CROP: "user_crop",
  ACTION_ERROR_LOG: "error_log",
  ACTION_DELETE_STAGE_IMAGE: "delete_stage_image",
  ACTION_DAKSH_COMPETITOR_HYBRID: "daksh_competitor_hybrid",
  ACTION_CROP_SEASON_SUB_ACTIVITY: "crop_season_sub_activity",
}

export const DASHBOARD_SCREEN = {
  NEW_KRISHAK: "Krishak",
  NEW_PRERAK: "Prerak",
  ACTIVITIES_COMPLETED: "Activities Completed",
  ACTIVE_USERS: "Active Users",
  ACTIVE_TEHSILS: "Active Tehsils",
  ACTIVE_HYBRIDS: "Active Hybrids",
  ACTIVITIES_COMPLETED_PLANNED_USERS: "Activities Completed/Planned by Users",
  SELECT_DATE_RANGE: "Select Date Range",
  YESTERDAY: "Yesterday",
  LAST_7_DAYS: "Last 7 Days",
  LAST_30_DAYS: "Last 30 Days",
  CUSTOM_RANGE: "Custom Range",
  SELECT_ITEMS_DOWNLOAD: "Select Items to Download",
  LAST_MONTH: "Last Month",
  LAST_QUARTER: "Last Quarter",
  LAST_YEAR: "Last Year",
}

export const FOOTER_SCREEN = {
  ALL_RIGHTS_RESERVED: "All Rights Reserved",
  ABOUT_US: "About us",
  IMAGES: "Images"
};

export const ADD_KRISHAK_SCREEN = {
  GENERAL: "General",
  CROPPING: "Cropping",
  BRAND_LOYALTY: "Brand Loyalty",
  LAST_STEP: "Last Step",
  PERSONAL_DETAILS: "Personal Details",
  LOCATION_DETAILS: "Location Details",
  ADDITIONAL_DETAILS_OPTIONAL: "Additional Details (Optional)",
  IRRIGATION_SOURCE: "Irrigation Source",
  SELECT_STATE: "Select State",
  SELECT_CITY: "Select City",
  SELECT_DISTRICT: "Select District",
  SELECT_TEHSIL: "Select Tehsil",
  SELECT_VILLAGE: "Select Village",
  ADDITIONAL_DETAILS: "Additional Details",
  OPTIONAL: "Optional",
  EDUCATIONAL_QUALIFICATION: "Educational Qualification",
  ILLITERATE: "Illiterate",
  SCHOOL: "School",
  COLLEGE: "College",
  SMART_PHONE_USER: "Smart Phone User?",
  SELECT_APP_USED: "Select App Used",
  CAN_BE_PRERAK: "Can be a Prerak?",
  KNOW_YOUR_PRERAK: "Know your Prerak?",
  KRISHAK_ALREADY_EXIST: "Krishak Already Exist!",
  ENTER_PRERAK_NAME_NUMBER: "Enter Prerak Name or Mobile Number",
  TUBEWELL: "Tubewell",
  CANAL: "Canal",
  WELL: "Well",
  US_BRANDS: "US Brand",
  OTHER_BRANDS: "Other Brands",
  RAINFED: "Rainfed",
  TOTAL_OWNED: "Total Owned",
  TOTAL_LEASED: "Total Leased",
  IRRIGATED: "Irrigated",
  INFORMATION_ABOUT_CROPS_PLANTED: "Information about Crops Planted",
  SELECT_ONE_OR_MULTIPLE: "Select one or multiple",
  BRAND_PURCHASED: "Brands Purchased",
  US_HYBRIDS_PURCHASED: "US Hybrids Purchased",
  OTHER_BRAND_HYBRIDS_PURCHASED: "Other Brand Hybrid Purchased",
  SOURCE_INFORMATION_SEEDS: "Source of Information of Seeds",
  SELECT_ANY_ONE: "Select any one",
  FACTORS_INFLUENCING_PURCHASE_INTENTION: "Factors Influencing Purchase Intention",
  CREDIT_AVAILABILITY: "Credit Availability",
  LAST_SEASON_YIELD: "Last Season Yield",
  WATER_AVAILABILITY: "Water Availability",
  FELLOW_FARMER_ADVISE: "Fellow Farmer Advice",
  DEALER_SUGGESTION: "Dealer Suggestion",
  GOOD_PROMOTION: "Good Promotion",
  COST_OF_SEED: "Cost of Seed",
  BRAND_EQUITY: "Brand Equity",
  PEST_DISEASE_RESISTANCE: "Pest & Disease Resistance",
  POINTS_OF_DECISION_MAKING: "Points of Decision Making",
  FAVOURITE_TV_SHOW: "Favourite TV Show",
  FAVOURITE_RADIO_SHOW: "Favourite Radio Show",
  FAVOURITE_NEWSPAPER: "Favourite Newspaper",
  ADD_FELLOW_FARMER_MOBILE_NUMBER: "Add Fellow Farmer Mobile Numbers",
  SELECT_CROPS_PLANTED: "Select Crops Planted",
  SELECT_US_HYBRID: "Select US Hybrid",
  SELECT_OTHER_BRAND_HYBRID: "Select Other Brand Hybrid",
  SELECT_NEAREST_AGRI_DISTRIBUTOR_RETAILER: "Select Nearest Agri Distributor/Retailer",
  NEAREST_AGRI_DISTRIBUTOR_RETAILER: "Nearest Agri Distributor/Retailer",
  IMAGES: "Images",
  REMARKS: "Remarks",
  IF_ANY: "if any",
  TYPE_OF_SOURCE: "Type of source",
  US_HYBRIDS: "US Hybrids",
  OTHER_BRANDS_HYBRIDS: "Other Brands Hybrids",
  TYPE_HERE: "Type here",
  FELLOW_FARMER: "Fellow Farmer",
  FELLOW_FARMER_MOBILE_NUMBERS: "Fellow Farmers Mobile Numbers",
};

export const CALENDER_SCREEN = {
  ACTIVE_FDO: "Active FDOs",
  ACTIVITIES_COMPLETED: "Activities Completed",
  ACTIVITIES_REVIEWED: "Activities Reviewed",
  INDIVIDUAL_VISIT: "Individual Visit",
  SAMPLE_DISTRIBUTION: "Sample Distribution",
  GROUP_MEET: "Group Meeting",
  SAMPLE_TO_SALE: "Sample to Sale",
  FARMER_NAME: "Farmer Name",
  RETAILER_NAME: "Retailer Name"
};

export const SAMPLE_TO_SALE_SCREEN = {
  ACTIVITY_HISTORY: "Activity History",
  HARVEST_4_DETAILS: "Harvest 4 Details",
  FIELD_DAMAGE: "Field Damage",
  SHOWING_AND_TRANSPLANTATION: "Sowing and Transplantation",
  SOWING: "Sowing",
  TRANSPLANTATION: "Transplantation",
  PLOT_VISIT: "Plot Visit",
  FIELD_DAY: "Field Day",
  HARVEST_DETAILS: "Harvest Details",
  GERMINATION: "Germination",
  FRUIT_QUALITY: "Fruit Quality",
  PEST_AND_DISEASE: "Pest & Disease",
  SHOWING_DATE: "Sowing Date",
  TRANSPLANTATION_DATE: "Transplantation Date",
  IRRIGATION_TYPE: "Irrigation Type",
  SPACING: "Spacing",
  REMARKS: "Remarks",
  GO_HERE: "go here",
  STAGE_DAT: "Stage (DAT)",
  CROP_HEALTH: "Crop Health",
  ATTENDED_BY: "Attended by",
  MANAGERS: "Managers",
  TERRITORY_MANAGERS: "Territory Managers",
  COMMITMENT: "Commitment",
  RETAILERS: "Retailers",
  HARVESTING_DATE: "Harvesting Date",
  YIELD: "Yield",
  MOISTURE: "Moisture",
  POPULATION: "Population",
  VARIETY_HYBRID: "Variety Hybrid",
  HYBRID_NAME: "Hybrid Name",
  DAMAGE_DUE_TO: "Damaged Due to",
  ADVERSE_WEATHER: "Adverse Weather",
  LOW_MAINTENANCE: "Low Maintenance",
  PEST_DISEASE: "Pest & Disease",
  OTHERS: "Others",
  VARIETY: "Variety",
  HYBRID: "Hybrid",
  GPS_COORDINATES: "GPS Co-ordinates",
  GPS_ERROR: "Switch on the GPS on your phone to get Co-ordinates",
  NEXT_PICKING_ACTIVITY_DONE: "Next picking activity to be done?",
  STAGE: "Stage",
  CHECK_HARVEST_DETAILS: "Check Harvest Details",
};

export const MORE_MENU_SCREEN = {
  MY_PROFILE: "My Profile",
  NOTIFICATIONS: "Notifications",
  CHANGE_PASSWORD: "Change Password",
  RETAILER_REGISTRATION: "Retailer Registration",
  SEND_FEEDBACK: "Send Feedback",
  CONTACT_US: "Contact US",
  ABOUT_THE_APP: "About the App",
  PRIVACY_POLICY: "Privacy Policy",
  LOGOUT: "Logout",
  INFORMATION: "Information",
  EDIT_PROFILE: "Edit profile",
  ABOUT_US: "About us",
  RELATED_TOPIC: "Related Topic",
  COMMENTS_SUGGESTIONS: "Comments / Suggestions",
  //COPYRIGHT_TITLE: "©Copyright 2020 Safal. All Rights Reserved.",
  COPYRIGHT_TITLE: `©Copyright ${new Date().getFullYear()} Safal. All Rights Reserved.`,
};

export const ADD_ACTIVITY_SCREEN = {
  ADD_ACTIVITY_FOR: "Adding Activity for",
};

export const HOME_TODAY_SCREEN = {
  INDIVIDUAL_VISIT_FARMER: "Individual Visit - Farmer",
  INDIVIDUAL_VISIT_RETAILER: "Individual Visit - Retailer",
  SAMPLE_DISTRIBUTION: "Sample Distribution",
  GROUP_MEET: "Group Meeting",
  SAMPLE_TO_SALE: "Sample To Sale",
  INDIVIDUAL_VISIT: "Individual Visit",
  STATUS_COMPLETED: "Completed",
  STATUS_IN_PROGRESS: "In Progress",
  STATUS_TO_START: "To Start",
  STATUS_TO_RESUBMIT: "To Resubmit",
  FARMER: "Farmer",
  RETAILER: "Retailer",
  YOUR_PLAN_FOR_THE_DAY: "Your plan for the day",
  TODAYS_ACTIVITIES_FOR: "Today's Activities for ",
  START_DAY: "Start Day",
  END_DAY: "End Day",
  DAY_STARTED: "Day Started",
  PENDING_ACTIVITIES: "Pending Activities",
  DAY_ENDED: "Day Ended",
  ENTER_THE_MOBILE_NUMBER_OF_THE_FARMER: "Enter Mobile Number of the Farmer",
  GO: "GO",
  ENTER_THE_MOBILE_NUMBER: "Enter Mobile Number",
  BULK_UPLOAD: "BULK UPLOAD",
};

export const DAKSH_SCREEN = {
  DAKSH: "Daksh",
  SALE: "Sale",
  PLAN: "Plan",
  SEEDWORKS_SALE: "Seedworks Sale",
  COMPETITOR_SALE: "Competitor Sale",
  US_AGRISTAR_POINTS: "US Agristar Points",
  US_AGRISTAR_STAR_CATEGORY: "US Agristar Star Category",
  VALIDATE: "VALIDATE"
};

export const ALL_ROUTES = {
  SPLASH_ROUTE: "/splash",
  SIGN_IN_ROUTE: "/login",
  FORGOT_PASSWORD_ROUTE: "/forgot-password",
  OTP_ROUTE: "/otp",
  SET_NEW_PASSWORD_ROUTE: "/set-new-password",
  LOGIN_WITH_OTP_ROUTE: "/login-with-otp",
  VERIFY_OTP: '/verify-otp',

  //Home Screens Routes
  HOME_TODAY_ROUTE: "/home-today",
  MANAGER_HOME_TODAY_ROUTE: "/manager-home-today",
  MANAGER_FDO_DETAIL_ROUTE: "/manager-fdo-detail",
  ADD_ACTIVITY_ROUTE: "/add-activity",
  ADD_FARMER_ROUTE: '/AddFarmer',
  ADD_SAMPLE_DISTRIBUTION_ROUTE: '/add-sample-distribution',
  ADD_GROUP_MEET_ROUTE: '/add-group-meeting',

  //Activity Route
  EDIT_INDIVIDUAL_VISIT: "/edit-individual-visit",
  EDIT_SAMPLE_DISTRIBUTION_ROUTE: "/edit-sample-distribution",
  EDIT_SAMPLE_TO_SALE: "/edit-sample-to-sale",
  EDIT_GROUP_MEETING_ROUTE: "/edit-group-meeting",


  //More Menu Routes
  MORE_MENU_ROUTE: "/more-menu",
  MY_PROFILE_ROUTE: "/myprofile",
  NOTIFICATIONS_ROUTE: "/notifications",
  CHANGE_PASSWORD_ROUTE: "/change-password",
  SEND_FEEDBACK_ROUTE: "/send-feedback",
  CONTACT_US_ROUTE: "/contact-us",
  ABOUT_THE_APP_ROUTE: "/about-the-app",
  PRIVACY_POLICY_ROUTE: "/privacy-policy",
  RETAILER_REGISTRATION_ROUTE: "/retailer-registration",

  //Calender Routes
  CALENDAR_ROUTE: "/calendar",
  CALENDAR_DAY_ROUTE: "/calendar-day",
  CALENDAR_DAY_FDO_SCHEDULE_ROUTE: "/calendar-day-fdo-schedule",
  ACTIVITY_DETAILS_ROUTE: "/activity-details",
  INDIVIDUAL_VISIT_DETAILS_ROUTE: "/individual-visit-details",
  SAMPLE_DISTRIBUTION_DETAILS_ROUTE: "/sample-distribution-details",
  GROUP_MEETING_DETAILS_ROUTE: "/group-meeting-details",
  GROUP_MEETING_VIEW_ROUTE: "/group-meeting-view",
  SAMPLE_TO_SALE_DETAILS_ROUTE: "/sample-to-sale-details",
  SAMPLE_TO_SALE_VIEW_ROUTE: "/sample-to-sale-view",


  //Dashboard Routes
  DASHBOARD_ROUTE: "/dashboard",
  DASHBOARD_ACTIVITIES_ROUTE: "/dashboard/activities",
  DASHBOARD_USERS_ROUTE: "/dashboard/users",
  DASHBOARD_TEHSILS_ROUTE: "/dashboard/tehsils",
  DASHBOARD_HYBRIDS_ROUTE: "/dashboard/hybrids",

  //Sample To Sale Routes
  SAMPLE_TO_SALE_ROUTE: "/sample-to-sale",
  HARVEST_DETAILS_ROUTE: "/harvest-details",
  FIELD_DAMAGE_ROUTE: "/field-damage",
  ACTIVITY_HISTORY_ROUTE: "/activity-history",
  SHOWING_TRANSPLANTATION_ROUTE: "/showing-transplantation",
  TRANSPLANTATION_ROUTE: "/transplantation",
  PLOT_VISIT_ROUTE: "/plot-visit",
  FIELD_DAY_ROUTE: "/field-day",
  ADD_HARVEST_ROUTE: "/add-harvest",
  ADD_GERMINATION_ROUTE: "/add-germination",
  ADD_FRUIT_QUALITY_ROUTE: "/add-fruit-quality",
  ADD_PEST_DISEASE_ROUTE: "/add-pest-and-disease",


  //Krishak Screens Routes
  ADD_KRISHAK_ROUTE: "/add-krishak",
  ADD_INDIVIDUAL_VISIT_ROUTE: "/add-individual-visit",
  KRISHAK_INFO_ROUTE: "/krishak-info",

  //Reports Routes
  REPORTS_ROUTE: '/reports',
  FARMER_REPORTS_ROUTE: "/farmer-reports",
  USER_LOCATION_REPORTS_ROUTE: "/user-location-reports",
  INDIVIDUAL_VISIT_REPORTS_ROUTE: "/individual-visit-reports",
  SAMPLE_DISTRIBUTION_REPORTS_ROUTE: "/sample-distribution-reports",
  GROUP_MEETING_REPORTS_ROUTE: "/group-meeting-reports",
  SAMPLE_TO_SALE_REPORTS_ROUTE: "/sample-to-sale-reports",
  USER_STATUS_REPORTS_ROUTE: "/user-status-reports",
  PRERAK_REPORTS_ROUTE: "/prerak-reports",
  BULK_UPLOAD_ROUTE: "/bulk-upload",

  //Daksh Module Route
  DAKSH_ROUTE: "/daksh",
  SALE_DETAILS_ROUTE: "/sale-details",
  PLAN_DETAILS_ROUTE: "/plan-details",
  ADD_SEEDWORKS_SALE: "/add-seedworks-sale",
  ADD_COMPETITOR_SALE: "/add-competitor-sale",
  DAKSH_APPROVAL_ROUTE: "/daksh-approval",
  DAKSH_APPROVE_REJECT: "/daksh-approve-reject",
  SUBMIT_SALE_ROUTE: "/submit-sale",
  DAKSH_DETAILS_ROUTE: "/daksh-details"

};

export const TIMER_COUNT = {
  TEN_SECOND_DELAY: 10000,
  ONE_MINUTE_DELAY: 60000,
};

export const API_CONSTANTS = {
  // SYNC SERVICE //
  SYNC_DATA: "syncData",
  SYNC_KRISHAK_DATA: 'syncKrishakData',
  SYNC_ACTIVITY_DATA: 'syncActivityData',

  // LOGIN MODULE //
  LOGIN_URL: "login",
  SEND_OTP_URL: "otp/resend",
  VERIFY_OTP_URL: "otpVerify",
  FORGOT_PASSWORD: "forgotPassword",
  LOGOUT: "logout",
  CHANGE_PASSWORD: "changePassword",
  SENT_RETAILER_OTP: "sentRetailerOtp",
  VERIFY_RETAILER_OTP: "verifyRetailerOtp",
  ADD_RETAILER: "addRetailer",


  // HOME TODAY MODULE //
  GET_TODAY_ACTIVITY: "getTodayActivity",
  GET_FDO_ACTIVITY_BYDATE: "getFdoActivityByDate",
  DELETE_ACTIVITY_IMAGE: "deleteActivityImage",
  DELETE_KRISHAK_IMAGE: "deleteKrishakImage",
  GET_KRISHAK_BY_REFERENCE_ID: "getKrishakByReferenceId",
  DELETE_KRISHAK_FELLOW_FARMER_IMAGE: "deleteKrishakFellowFarmerImage",
  DELETE_GROUP_MEETING_IMAGE: "deleteGroupMeetingImage",
  DELETE_GM_FARMER_IMAGE: "deleteGroupMeetingFarmerImage",
  START_END_DAY: "addUserStartEndDay",

  // Added By Krunal 
  GET_ALL_CROP_HYBRID_BY_USER_LOCATION: "GetAllCropHybridByUserLocation",
  GET_ALL_USER_LOCATION_BY_HYBRID: "GetAllUserLocationByHybrid",


  // HOME TODAY - ADD ACTIVITY MODULE //
  GET_FDO: "getFDO",
  GET_ACTIVITY_FDO: "getActivityFDO",
  GET_ALL_ACTIVITY_TYPE: "getAllActivityType",
  GET_ALL_CROP: "getAllCrop",
  GET_SUBACTIVITY_BY_ID: "getSubActivityByReferenceId",
  GET_SUBACTIVITY_BYID: "GetAllActiveCropByUserLocation",
  GET_HYBRID_BY_ID: "getHybridByReferenceId",
  GET_ALL_VILLAGE: "getAllVillage",
  ADD_ACTIVITY: "addActivity",
  GET_TYPE_OF_SAMPLE: "getTypeOfSample",
  EDIT_ACTIVITY: "editActivity",
  GET_ACTIVITY_BY_ID: "getActivityById",
  ACTIVITY_BULK_UPLOAD: "activityBulkUpload",
  GET_RETAILER_BY_ACTIVITY_ID: "getRetailerByActivityId",
  GET_CHECK_VARIETY_BY_REFERENCE_ID: "getCheckVarietyByReferenceId",
  GET_GROVER_BY_USER_ID: "GetGroverByUserId",

  //Dashboard Module
  GET_DASHBOARD_DATA: "GetDashboardData",
  GET_DASHBOARD_DOWNLOAD_DATA: "GetDashboardDownloadData",

  GET_DASHBOARD_MASTER_DATA: "GetDashboardMasterData",
  GET_DASHBOARD_ACTIVITY_DATA: "GetDashboardActivityData",
  GET_DASHBOARD_USER_DATA: "GetDashboardUserData",
  GET_DASHBOARD_TEHSIL_DATA: "GetDashboardTehsilData",
  GET_DASHBOARD_HYBRID_DATA: "GetDashboardHybridData",

  //Calender Module
  GET_CALENDAR_ACTIVITY_BY_MONTH: "getCalendarActivityByMonth",
  GET_ACTIVITY_BY_DATE: "getActivityByDate",
  GET_USER_ACTIVITY_BY_DATE: "getUserActivityByDate",
  EDIT_ACTIVITY_BY_ID: "editActivityById",
  GET_ALL_REJECT: "getAllActiveReject",
  ADD_ACTIVITY_REJECT: "addActivityReject",

  //Sample To Sale Module
  IS_SAMPLE_TO_SALE: "isSampleToSale",
  STORE_SAMPLE_TO_SALE_BY_ID: "storeSampleToSaleById",
  GET_CROP_DAYS_BY_CROP_ID: "getCropDaysByCropId",


  // KRISHAK MODULE //
  GET_ALL_STATES: "getAllState",
  KRISHAK_REPORT: "krishakReport",
  GET_USER_LOCATION_REPORT: "getUserLocation",
  GET_USER_FEEDBACK_BY_USER_ID: "getUserFeedbackByUserId",
  EXPORT_KRISHAK_REPORT: "exportKrishakReport",
  EXPORT_USER_LOCATION_REPORT: "exportUserLocation",
  EXPORT_ACTIVITY_REPORT: "exportActivityReport",
  EXPORT_USER_REPORT: "exportUserReport",
  GET_ACTIVITY_REPORT: "getActivityReport",
  FARMER_REPORT: "farmerReport",
  USER_REPORT: "userReport",
  PRERAK_REPORT: "prerakReport",
  GET_ALL_PRERAK: "GetAllPrerak",
  GET_ALL_CROP_GROUP: "getAllActiveCropGroup",
  GET_ALL_APPS: "getAllPhoneApp",
  GET_ALL_CROPS: "getAllCrop",
  GET_ALL_ACTIVE_CROP: "GetAllActiveCrop",
  GET_ALL_USER_FEEDBACK: "getAllActiveUserFeedbackTopic",
  GET_ALL_QUALIFICATION: "getAllQualification",
  ADD_KRISHAK: "addkrishak",
  ADD_USER_FEEDBACK: "addUserFeedback",
  UPDATE_USER_IMAGE: "updateUserImage",
  GET_USER_NOTIFICATION: "getUserNotification",
  UPDATE_USER_NOTIFICATION: "updateUserNotification",
  EDIT_USER: "editUser",
  GET_ALL_WEIGHT_UNIT: "getAllWeightUnit",
  GET_ALL_AREA_UNIT: "getAllAreaUnit",
  //GET_USER_BY_ID: "getUserById",
  GET_USER_BY_ID: "getUserByToken",
  EDIT_KRISHAK: "editkrishak",
  DELETE_KRISHAK: "deletekrishak",
  GET_KRISHAK_BY_ID: "getKrishakById",
  GET_ALL_RETAILERS: "getAllRetailer",
  GET_KRISHAK_PARAM: "getKrishakParam",
  GET_HYBRID_BY_MULTI_CROP: "getHybridByMultiCrop",
  GET_COMPETITOR_HYBRID_BY_MULTI_CROP: "getCompetitorHybridByMultiCrop",
  GET_ALL_SOURCE_OF_INFORMATION: "getAllKrishakSourceOfInformation",
  GET_ALL_INFLUENCE_FACTORS: "getAllInfluenceFactor",
  GET_ALL_DECISION_MAKING: "getAllKrishakDecisionMaking",
  GET_ALL_IRRIGATION_SOURCE: "getAllIrrigationSource",
  GET_ALL_HYBRIDS: "getAllHybrid",
  GET_ALL_VILLAGE_BY_ID: "getAllVillageByReferenceId",
  GET_ALL_DISTRICT_BY_ID: "getAllDistrictByReferenceId",
  GET_ALL_TEHSIL_BY_ID: "getAllTehsilByReferenceId",
  GET_ADDRESS_FROM_LAT_LONG: "GetAddressFromLatLong",
  GET_AVAILABLE_MOBILE_NUMBER: "getAvailableMobileNumber",

  //Reports Module
  GET_USER_STATE: "getUserState",
  GET_ALL_ACTIVE_DISTRICT: "getAllActiveUserDistrict",
  GET_ACTIVE_TEHSIL_BY_DISTRICT_ID: "getAllActiveUserTehsil",
  GET_ALL_VILLAGE_BY_USER: "getAllVillageByUser",
  GET_USER_CROP_GROUP: "getUserCropGroup",
  GET_USER_CROP: "getUserCrop",
  GET_TYPE_OF_SAMPLE_BY_USER: "getTypeOfSampleByUser",
  GET_ACTIVE_SEASON: "getActiveSeason",
  GET_SUB_ACTIVITY_BY_USER: "getSubActivityByUser",
  EXPORT_PRERAK_REPORT: "exportPrerakReport",
  GET_USER_REPORTING_USER_DETAILS: "getUserReportingUserDetails",
  GET_USER_REPORTS: "getUserReport",


  //Daksh Module
  ADD_DAKSH_DATA: "addDakshData",
  GET_DAKSH_DATA_BY_RETAILER_ID: "getDakshDataByRetailerId",
  GET_OTP_CODE_IN_DAKSH: "getOTPCodeInDaksh",
  VALIDATE_OTP: "validateOTP",
  GET_DAKSH_APPROVAL_LIST: "getDakshApprovalList",
  GET_DAKSH_DATA_BY_DAKSH_ID: "getDakshDataByDakshId",
  UPDATE_DAKSH_STATUS: "updateDakshStatus",
  GET_DAKSH_REJECT_REASON: "getDakshRejectReason",


  // --- KEY AREA --- // 
  ACCESS_TOKEN: "myAccessToken",
  TOKEN: "token",
  REDIRECT_URL: "redirectUrl",
  REFRESH_TOKEN: "refreshToken",
  IS_LOGIN: "isLogin",
  USER_PREFRENCES: "userPrefrences",
  BULK_DATA: "bulkData",
  NOTIFICATION_COUNT: "notificationCount",
};


export const FILE_CONSTANT = {
  TERMS_CONDITIONS_FILE: "/terms.html",
  PRIVACY_POLICY_FILE: "/privacy-policy.html",
};

export const APP_INFO = {
  VERSION: "Version : 0.7.0",
  UPDATE_ON: "Updated On: 20-Mar-2025"
}

export const DEV_MODE = true;

export const DEV_ENV = {
  //BASE_URL: "https://safalbetaapi.seedworks.com/api/",
  BASE_URL: "https://safalapi.seedworks.com/api/",
  BEARER_TOKEN: "Bearer mhZg4OwbDnBA_bKWhSc0jHKKjAW0Yu",
};

export const PROD_ENV = {
  //BASE_URL: "https://safalbetaapi.seedworks.com/api/",
  BASE_URL: "https://safalapi.seedworks.com/api/",
  BEARER_TOKEN: "Bearer 9wRbJPloiTtrZF_CyZv7tcnH3swRg_jF",
};

export const ENVIRONMENT = {
  BASE_URL: DEV_MODE ? DEV_ENV.BASE_URL : PROD_ENV.BASE_URL,
  BEARER_TOKEN: DEV_MODE ? DEV_ENV.BEARER_TOKEN : PROD_ENV.BEARER_TOKEN,
  HELP_DESK_API: "http://helpdesk.seedworks.com:9090/api/v3/attachments?TECHNICIAN_KEY=F668F47A-1DC1-4963-A181-5A5D11B7E0F4"
};


export const APP_CONSTANTS = {
  APP_USER: "user",
  RETAILER: "retailer",
  NOTIFICATION_COUNT: "notificationCount",
}

export const APP_CONFIG = {
  //USER_KEY: 'user_key',
  USER_KEY: 'SAFALsecretSEEDWORKS'
}

export const COMMON_VALUE = {
  DEFAULT_SYNC_DATE: '2020-01-01 00:00:00'
}

export const PERMISSION_CONSTANTS = {
  DASHBOARD_VIEW: "71c28e60-405f-4bf7-9a5d-98693fc4aa4d",
  DASHBOARD_DOWNLOAD: "a809c43e-a571-4fb8-81d4-d1191b4033be",
  DASHBOARD_VIEW_ACTIVITY: "0d002870-aba9-46cd-ad7d-6b0d66b8b23e",
  DASHBOARD_VIEW_USERS: "0d002870-aba9-46cd-ad7d-6b0d66b8b23e",
  DASHBOARD_VIEW_TEHSIL: "a566f592-616e-467e-861f-2c80e3b79c64",
  DASHBOARD_VIEW_HYBRIDS: "6a492f0f-9070-4ff5-bd40-ac88666e2b74",

  CALENDAR: "d39f2523-49d8-4335-aba8-dc9a7323111d",
  CALENDAR_DAY: "c8b50f31-bf80-4fed-8098-3d972ed42aa2",
  CALENDAR_USER_DETAILS: "4c0e6455-0751-481a-8031-89af15f7076c",

  ADD_ACTIVITY_INDIVIDUAL_VISIT: "40f56a5c-8a66-4b98-af6e-57cf09dfd1f7",
  ADD_ACTIVITY_SAMPLE_DISTRIBUTION: "97e13cf1-ac31-4586-9844-7ae7b6ec5b73",
  ADD_ACTIVITY_GROUP_MEETING: "e8ea4fd3-ad20-4c18-a578-0e588e2d31a7",
  ADD_ACTIVITY_SAMPLE_TO_SALE: "cd14e3b3-0f5e-4ceb-b89b-d9958d328900",
  START_DAY_AND_END_DAY: "66b37f90-2fb3-4681-85e0-cb0c8138aba2",
  BULK_UPLOAD: "b8d7ee99-286c-4f83-99f4-dd1b7b8c5137",
  EXECUTE_INDIVIDUAL_VISIT: "fb91526c-46c8-426b-bd94-dfcd8ca73cb7",
  EXECUTE_SAMPLE_DISTRIBUTION: "26029508-56a7-4ab5-9b5b-36af63b04d3f",
  EXECUTE_GROUP_MEETING: "05ef1ae2-9a05-4d4a-9aa9-3bf3c536d3df",
  EXECUTE_SAMPLE_TO_SALE: "af290453-83dd-4f53-9661-1dc372d33cc1",
  EDIT_ACTIVITY: "8f7c61d0-ba6c-4965-8780-340959edbf58",
  DELETE_ACTIVITY: "08026fc8-6ed4-4035-97dc-b7bc962029fb",
  ACCEPT_ACTIVITY: "6f582437-24ac-41df-bcd9-e4f8d66b1c9d",
  REJECT_ACTIVITY: "3284e868-f939-439e-8fde-9abvv263lsaa",

  VIEW_KRISHAK_INFO: "8f7c61d0-ba6c-4965-8780-340kkk568f58",
  ADD_KRISHAK: "8f7c61d0-ba6c-4965-8780-340kk54abf58",
  EDIT_KRISHAK: "8f7c61d0-ba6c-4965-8780-340kkaa55f58",
  DELETE_KRISHAK: "8f7c61d0-ba6c-4965-8780-340959edb111",

  KRISHAK_REPORT: "6d834777-5661-4e22-96ff-f7cd35b23da2",
  INDIVIDUAL_VISIT_REPORT: "e88cad7d-8abc-4429-8c3c-80904e8fe674",
  SAMPLE_DISTRIBUTION_REPORT: "bca34cd2-9aad-4444-847f-3dc3016be174",
  GROUP_MEET_REPORT: "1bf8527b-086f-42d9-b482-5357c9297f3f",
  SAMPLE_TO_SALE_REPORT: "faea3929-3720-4b23-8598-0407d68bdfa8",
  FARMER_REPORT: "4f26e31d-91ad-46b4-b3ce-5581c23ebdc1",
  PRERAK_REPORT: "94f71020-9178-498e-9e39-b64ae60ffeeb",
  USER_STATUS_REPORT: "cf1e2f4c-e080-4546-867b-a4772de92a31",
  USER_LOCATION_REPORT: "740f352d-e1cf-4f5f-a03b-bcea71ffbc06",

  EDIT_PROFILE: "8f0a899e-63c4-4738-bd36-731e42983dc8",
  CHANGE_PASSWORD: "b786e054-8bd4-4ef5-bef0-028b6ad358e8",
  SEND_FEEDBACK: "45f25c0d-4faa-49b1-8b02-2d8badd25698",
  PRIVACY_POLICY: "d39f2523-49d8-4335-aba8-dc9a7323111d",
  ABOUT_APP: "2ff1aa59-c71e-473a-90a4-7ffbebdcd121",
  RETAILER_REGISTRATION: "044967fe-7c13-4639-b4bb-7704f0f62c7b",

  DAKSH: "9a84d6f3-dd59-4113-a568-9d71582e7c1f",
  DAKSH_APPROVAL: "2f821418-2322-4d9c-9a2e-1c4eb9264fef"

}



